import dcapital from './dcapital.es';
export default {
  nav: { home: 'Inicio', selection: 'Selección de traders', training: 'Formación', apply: 'Solicitar', signin: 'Entrar' },
  ticker: ['AAPL +1.24%', 'TSLA -0.87%', 'NVDA +2.41%', 'MSFT +0.66%', 'NASDAQ 18,412.55', 'NYSE 19,204.11', 'AMZN +1.02%', 'META -0.43%', 'GOOGL +0.95%', 'AMD +3.12%'],
  common: { result: 'Resultado', popular: 'Más popular', soldOut: 'Agotado', waitlistBtn: 'Lista de espera', soldOutHint: 'Grupo completo. Únete a la lista de espera a través del formulario.', choose: 'Elegir plan', start: 'Inicio', orPaypal: 'o paga con' },
  home: {
    heroOverline: 'Plataforma de trading profesional · NYSE & NASDAQ',
    heroLines: ['Opera el', 'mercado de acciones', 'estadounidense'],
    heroSub: 'Equipo prop de ALEF. Formamos traders desde cero y seleccionamos a los mejores: califica una vez y gestiona capital de hasta $1 000 000.',
    ctaPrimary: 'Pasar la selección',
    ctaSecondary: 'Programa de formación',
    stats: [
      { v: '$1M', l: 'Capital máximo', s: 'Crece con tu consistencia' },
      { v: '12 sem.', l: 'Programa de formación', s: 'Ruta paso a paso NYSE & NASDAQ' },
      { v: '1×', l: 'Una sola calificación', s: 'Tu cuenta escala automáticamente' },
    ],
    pillarsOverline: 'Tres caminos',
    pillarsTitle: 'Elige tu camino en el trading',
    pillars: [
      { num: '01', title: 'Selección de traders', desc: '¿Ya operas? Demuestra consistencia en la evaluación demo y obtén una cuenta real que escala hasta $1M.', cta: 'Solicitar selección' },
      { num: '02', title: 'Formación desde cero', desc: 'Programa de tres meses: desde las bases del mercado hasta tu propio sistema de trading, con clases en vivo y mentor.', cta: 'Ver el programa' },
      { num: '03', title: 'Carrera en el equipo', desc: 'Los mejores graduados y traders seleccionados operan el capital de la empresa, aumentan su reparto de beneficios y se convierten en mentores.', cta: 'Empezar el camino' },
    ],
    whyOverline: 'El mercado',
    whyTitle: '¿Por qué NYSE & NASDAQ?',
    whyItems: [
      'Las bolsas más grandes y líquidas del mundo',
      'Apple, Microsoft, Google, Tesla y miles más',
      'Más de $50 billones de capitalización bursátil',
      'Oportunidades cada día, 9:30–16:00 EST',
      'Herramientas profesionales y datos en tiempo real',
    ],
    benOverline: 'Ventajas',
    benTitle: 'Por qué ALEF TRADERS',
    benefits: [
      { t: 'Capital de alto rendimiento', d: 'Acceso a un capital considerable según tu consistencia y gestión del riesgo.' },
      { t: 'Soporte profesional', d: 'Equipo de soporte dedicado, herramientas avanzadas e infraestructura de nivel institucional.' },
      { t: 'Reparto de beneficios flexible', d: 'Un modelo competitivo de profit split que premia la consistencia y la disciplina.' },
      { t: 'Crecimiento profesional', d: 'Oportunidades de desarrollo, mentoría y crecimiento dentro del equipo.' },
    ],
    aboutOverline: 'Sobre nosotros',
    aboutName: 'ALEF TRADERS',
    aboutRole: 'Un equipo profesional de traders · NYSE & NASDAQ',
    aboutBio: 'ALEF Traders es un equipo de traders profesionales del mercado bursátil estadounidense. Estamos en los mercados desde 2012 y trabajamos profesionalmente desde 2017. En este tiempo el equipo ha gestionado un fondo de más de $10 000 000 y ha ganado más de $3 000 000. Hoy hacemos crecer nuestro propio equipo prop: formamos traders desde cero y ofrecemos a los mejores estudiantes y candidatos que superan la selección operar el capital de la empresa.',
    aboutStats: [
      { v: '2012', l: 'En mercados desde' },
      { v: '$10M+', l: 'Bajo gestión' },
      { v: '$3M+', l: 'Beneficio del equipo' },
    ],
    ctaTitle: '¿Listo para empezar tu carrera de trader?',
    ctaSub: 'Empieces desde cero o con años de experiencia, tenemos el camino adecuado para ti.',
    ctaBtn: 'Solicitar ahora',
  },
  selection: {
    overline: 'Para traders con experiencia',
    heroLines: ['Demuestra tu habilidad.', 'Gestiona capital', 'hasta $1 000 000'],
    heroSub: 'Sin entrevistas ni diplomas: solo tu trading. Supera la evaluación demo y opera el capital de la empresa en NYSE & NASDAQ.',
    ctaBtn: 'Solicitar selección',
    metrics: [
      { v: '$1M', l: 'Capital máximo' },
      { v: '30–50%', l: 'Reparto de beneficios' },
      { v: '2', l: 'Etapas de evaluación' },
      { v: '9:30–16:00', l: 'Sesión EST' },
    ],
    stepsOverline: 'Proceso',
    stepsTitle: 'Cómo funciona la selección',
    steps: [
      { num: '01', t: 'Solicitud', d: 'Rellena un formulario breve: cuéntanos tu experiencia y los mercados que operas.' },
      { num: '02', t: 'Etapa demo', d: 'Opera una cuenta demo bajo reglas de gestión de riesgo. Muestra consistencia y alcanza el objetivo de beneficio.' },
      { num: '03', t: 'Verificación', d: 'Confirma tu resultado en una segunda etapa con objetivos más suaves: verificamos el proceso, no la suerte.' },
      { num: '04', t: 'Cuenta real', d: 'Recibe capital bajo gestión. Con trading consistente tu cuenta escala — hasta $1 000 000.' },
    ],
    condOverline: 'Condiciones',
    condTitle: 'Reglas del juego',
    conditions: [
      'Mercados: acciones de NYSE & NASDAQ',
      'Límite diario de pérdida y límite de drawdown',
      'Objetivo de beneficio por etapa sin violar el riesgo',
      'Escalado de cuenta por rendimiento consistente',
      'Pagos regulares de beneficios según calendario',
    ],
    benOverline: 'Por qué nosotros',
    benTitle: 'Qué recibe un trader del equipo',
    priceOverline: 'Costo de participación',
    priceTitle: 'Selección de traders — dos formatos',
    plans: [
      {
        key: 'online', name: 'Online', price: '$999', note: 'Pago único: minicurso + evaluación',
        features: ['Minicurso de trading — acceso online a las grabaciones', 'Acceso a la etapa demo de evaluación', 'Revisión de resultados y feedback del equipo', 'Si tienes éxito: cuenta real con capital de la empresa', 'Escalado de capital hasta $1 000 000'],
        fit: 'Supera la selección desde cualquier lugar del mundo y a tu ritmo.',
      },
      {
        key: 'office', name: 'En la oficina', price: '$1 499', note: 'Pago único: todo lo del formato online + trabajo en la oficina', badge: true,
        features: ['Todo lo del formato online', 'Puesto de trabajo equipado en nuestra oficina durante todo el periodo de selección', 'Opera junto al equipo en tiempo real', 'Revisiones de operaciones en vivo y contacto diario con los mentores', 'Inmersión en el entorno de trabajo de traders profesionales', 'Revisión prioritaria de tus resultados'],
        fit: 'Para quienes quieren integrarse en el equipo lo antes posible y operar codo con codo con profesionales.',
      },
    ],
    priceBtn: 'Pagar y empezar la selección',
    payMethods: 'Pago con tarjeta (Stripe), PayPal o USDT (TRC20), justo después de una breve solicitud',
    ctaTitle: '¿Listo para la selección?',
    ctaSub: 'Deja tu solicitud: el equipo te contactará por Telegram en un día laborable.',
  },
  training: {
    badge: 'Inicio del grupo · 18 de enero de 2027 · inscripción abierta',
    heroLines: ['Formación', 'profesional', 'en trading'],
    heroSub: 'Desde los primeros pasos en el mercado hasta operar de forma independiente bajo la supervisión de un mentor.',
    ctaPrimary: 'Reservar una consulta',
    ctaSecondary: 'Ver los planes',
    countdownTitle: 'Hasta el inicio del grupo:',
    countdownUnits: { d: 'días', h: 'horas', m: 'minutos', s: 'segundos' },
    stats: [
      { v: '3 meses', l: 'Duración' },
      { v: 'Live', l: 'Clases online' },
      { v: 'Real', l: 'Mercado' },
      { v: 'Mentor', l: 'Acompañamiento' },
    ],
    approachOverline: 'Nuestro enfoque',
    approachQuote: '«Enseñamos la profesión de trader, no vendemos el sueño del enriquecimiento rápido.»',
    approachText1: 'La mayoría de los cursos se limitan a un paquete de videolecciones grabadas: teoría sin feedback, sin control y sin acompañamiento.',
    approachText2: 'Nuestro programa es diferente. El alumno recorre el camino completo: principiante → práctica → sistema propio de trading → operativa real.',
    compOverline: 'Qué incluye',
    compTitle: 'Seis componentes que hacen el resultado predecible',
    components: [
      { t: 'Teoría', d: 'Conocimientos fundamentales del mercado, instrumentos y estrategias.' },
      { t: 'Práctica', d: 'Gráficos reales, análisis de operaciones y entrenamiento de habilidades.' },
      { t: 'Feedback', d: 'Revisión individual de tus errores y decisiones.' },
      { t: 'Mentoría', d: 'Contacto directo con un trader en activo.' },
      { t: 'Comunidad', d: 'Chat privado con mentores y graduados.' },
      { t: 'Acompañamiento', d: 'Soporte en la transición a la cuenta real.' },
    ],
    princOverline: 'Por qué funciona',
    princTitle: 'Ocho principios que nos diferencian de los cursos grabados',
    principles: [
      'Clases en vivo en tiempo real',
      'Preguntas durante las clases',
      'Grabaciones de todas las sesiones: acceso para siempre',
      'Comunidad privada de traders en activo',
      'Análisis de situaciones reales del mercado',
      'Feedback individual sobre tus operaciones',
      'Creación de tu propio sistema de trading',
      'Acompañamiento hasta operar en real',
    ],
    roadOverline: 'Hoja de ruta',
    roadTitle: 'Mes 1 → Mes 2 → Mes 3',
    roadSub: 'Fundamentos → Práctica → Operativa real',
    months: [
      {
        num: '01', meta: '4 semanas · 3 clases por semana · 1–1,5 horas', title: 'Fundamentos del trader',
        items: ['Introducción a los mercados financieros', 'Cómo funciona el trading', 'Apertura de la cuenta de trading', 'Configuración de la plataforma', 'Trabajo con órdenes', 'Análisis técnico', 'Tendencias y niveles', 'Rupturas y giros', 'Estrategias de trading', 'Gestión del riesgo', 'Psicología del trading'],
        result: 'El alumno entiende el mercado y sabe analizar gráficos por sí mismo.',
      },
      {
        num: '02', meta: '4 semanas · 2 análisis por semana + trabajo individual · hasta 2 horas', title: 'Práctica y sistema propio de trading',
        items: ['Sesiones prácticas en directo', 'Análisis del mercado en tiempo real', 'Revisión de operaciones de los participantes', 'Análisis de errores', 'Teoría adicional', 'Feedback individual', 'Construcción del sistema propio', 'Creación del plan de trading'],
        result: 'El alumno obtiene un sistema de decisiones funcional y se prepara para operar de forma independiente.',
      },
      {
        num: '03', meta: '4 semanas · acompañamiento del mentor, 2 llamadas por semana · 1–1,5 horas', title: 'Salida a la operativa real',
        items: ['Preparación para operar en real', 'Control del cumplimiento de la gestión del riesgo', 'Análisis de operaciones reales', 'Supervisión del mentor', 'Ayuda en la adaptación psicológica'],
        result: 'El alumno empieza a operar de forma independiente bajo el control del mentor.',
      },
    ],
    formatOverline: 'Formato de aprendizaje',
    formatTitle: 'Clases en vivo + archivo de grabaciones',
    formatItems: [
      'Todas las clases son online vía Zoom / Google Meet',
      'Duración: 1–1,5 horas; análisis de operaciones hasta 2 horas',
      'En directo: preguntas durante la clase',
      'Cada sesión queda grabada',
      'Acceso al archivo durante todo el programa',
      'Repasa el material cuando quieras',
    ],
    commOverline: 'Comunidad privada',
    commTitle: 'Un chat donde se opera, no se «motiva»',
    commItems: ['Mentores y traders en activo', 'Alumnos del grupo actual', 'Graduados del programa', 'Discusión del mercado, análisis de operaciones, recomendaciones'],
    resOverline: 'Qué recibe el participante',
    resTitle: 'Nueve resultados concretos del programa',
    results: ['Formación desde cero', 'Clases en vivo', 'Práctica en el mercado', 'Acceso a grabaciones', 'Chat privado', 'Feedback individual', 'Sistema propio de trading', 'Soporte del mentor', 'Preparación para operar en real'],
    priceOverline: 'Formatos de participación',
    priceTitle: 'Elige la intensidad del acompañamiento',
    tiers: [
      {
        name: 'Formato grupal', price: '$2 599', size: 'Hasta 20 participantes', start: 'Inicio 18.01.2027', startDate: '2027-01-18T09:00:00-05:00',
        features: ['Curso completo de 3 meses', 'Todas las clases en vivo', 'Grabaciones durante el curso', 'Chat privado', 'Feedback básico'],
        fit: 'Para quienes quieren una formación completa al precio más accesible.',
      },
      {
        name: 'Grupo reducido', price: '$3 599', size: 'Hasta 10 participantes', start: 'Inicio 18.01.2027', startDate: '2027-01-18T09:00:00-05:00', badge: true,
        features: ['Todo lo del formato grupal', 'El doble de atención del mentor', 'Revisión semanal de tus operaciones', 'Plan de trading personal', 'Respuestas prioritarias en el chat', 'Grabaciones durante 3 meses más tras el curso'],
        fit: 'Para quienes quieren llegar antes a resultados estables gracias a la atención personal.',
      },
      {
        name: 'Individual', price: '$9 999', size: '1 a 1', start: 'Inicio en cualquier momento',
        features: ['6 meses de acompañamiento: 3 de formación + 3 de soporte', 'Programa personal', 'Llamadas individuales', 'Revisión completa de cada operación', 'Contacto directo con el mentor', 'Acompañamiento máximo'],
        fit: 'Para quienes necesitan el máximo resultado en el mínimo tiempo.',
      },
    ],
    aboutOverline: 'Sobre nosotros',
    outOverline: 'Resultados tras la formación',
    outTitle: 'Al final del programa, el alumno sabe:',
    outcomes: ['Analizar el mercado por sí mismo', 'Determinar puntos de entrada', 'Gestionar el riesgo', 'Operar con su propio sistema', 'Controlar las emociones', 'Llevar un diario de trading', 'Operar en cuenta real con un plan claro', 'Decidir como un profesional'],
    ctaTitle: 'Empieza tu camino en el trading hoy mismo',
    ctaSub: 'Reserva una consulta y descubre qué formato de formación encaja contigo.',
    ctaBtn: 'Solicitar ahora',
    ctaNote: 'Respondemos en un día laborable · 9:00–21:00 NY',
  },
  masterclass: {
    badge: 'Inicio 23 de septiembre',
    urgency: '¡Solo quedan 3 plazas!',
    heroLines: ['Masterclass', 'de trading', 'de 3 días'],
    heroSub: '3 videolecciones de 15–30 minutos + tareas prácticas. Apta tanto para principiantes como para traders con experiencia.',
    priceNow: '$59', priceOld: '$590', discount: '90% de descuento',
    ctaBtn: 'Inscribirme en la masterclass',
    bonus: 'Bonus tras el registro: ¡cómo conseguir hasta $1M de capital bajo gestión!',
    aboutOverline: 'Instructor',
    aboutTitle: 'Sobre la masterclass y el instructor',
    aboutText1: '¡Saludos! Soy un trader profesional con muchos años de experiencia en los mercados financieros. A lo largo de mi carrera he ayudado a cientos de personas a dominar el arte del trading y a empezar a ganar en los mercados.',
    aboutText2: 'Esta masterclass de 3 días es el resultado de mi experiencia práctica. Solo estrategias probadas y técnicas reales que funcionan tanto para principiantes como para traders experimentados.',
    forOverline: 'Audiencia',
    forTitle: 'Para quién es esta masterclass',
    forCards: [
      { t: 'Para principiantes', d: 'Aprenderás las bases del trading desde cero, entenderás cómo funcionan los mercados y darás tus primeros pasos con un mentor experimentado.' },
      { t: 'Para traders con experiencia', d: 'Perfecciona tus habilidades, aprende estrategias avanzadas de gestión del riesgo y aumenta tus beneficios de forma estable.' },
      { t: 'Para quienes buscan ingresos extra', d: 'El trading es una forma de crear una fuente adicional de ingresos dedicando solo 1–2 horas al día.' },
    ],
    getOverline: 'Contenido',
    getTitle: 'Qué vas a recibir',
    getItems: [
      { t: '3 videolecciones', d: 'Lecciones diarias de 15–30 minutos con tareas prácticas.' },
      { t: 'Materiales extra', d: 'Checklists, plantillas y recursos útiles para tu aprendizaje.' },
      { t: 'Soporte', d: 'Acceso al bot de Telegram para materiales y soporte.' },
      { t: 'Comunidad', d: 'Comunidad privada de traders con los mismos objetivos.' },
    ],
    progOverline: 'Programa',
    progTitle: 'Programa de la masterclass',
    days: [
      { num: '1', label: 'Día 1', t: 'Inicio y estrategias de entrada', d: 'Qué mercados operar y por qué. Herramientas y espacio de trabajo. Zonas de oferta/demanda y triggers de entrada. Errores frecuentes de los principiantes.' },
      { num: '2', label: 'Día 2', t: 'Gestión del riesgo y disciplina', d: 'Tamaño de posición. Stop-loss y take-profit. Planificación por escenarios.' },
      { num: '3', label: 'Día 3', t: 'Psicología del trading', d: 'Control de emociones y gestión de pérdidas. Disciplina y rutina de trading. Formación de la mentalidad del trader profesional. Checklist final y paso a la operativa independiente.' },
    ],
    bonusOverline: 'Bonus especial',
    bonusNote: 'para quienes completen toda la masterclass',
    bonusTitle: 'Cómo conseguir hasta $1M de capital bajo gestión',
    bonusText: 'Guía exclusiva sobre cómo superar la selección de las empresas de prop trading y recibir hasta un millón de dólares de capital para operar.',
    achOverline: 'Resultados',
    achTitle: 'Qué vas a lograr',
    achieves: [
      { t: 'Estabilidad', d: 'Aprende a operar de forma estable y segura.' },
      { t: 'Beneficio', d: 'Empieza a generar ingresos regulares.' },
      { t: 'Habilidades', d: 'Domina técnicas profesionales.' },
      { t: 'Confianza', d: 'Gana confianza en tus decisiones.' },
    ],
    resOverline: 'Casos',
    resTitle: 'Resultados reales',
    resText: 'Resultados de los alumnos tras completar la masterclass y aplicar el sistema en la práctica.',
    cmpOverline: 'Comparación',
    cmpTitle: 'Por qué esta masterclass',
    usTitle: 'Esta masterclass',
    themTitle: 'Otros cursos',
    us: ['Estrategias probadas por un practicante', 'Solo información actualizada de 2026', 'Casos y ejemplos reales', 'Tareas prácticas cada día', 'Acceso a la comunidad de Telegram', 'Bonus: el camino al capital de $1M'],
    them: ['Teoría obsoleta de los libros', 'Frases genéricas sin concreción', 'Sin ejemplos prácticos', 'Solo vídeos, sin tareas', 'Sin soporte ni comunidad', 'Precio inflado por información básica'],
    faqOverline: 'FAQ',
    faqTitle: 'Preguntas frecuentes',
    faqs: [
      { q: 'Soy principiante, ¿me sirve esta masterclass?', a: 'Sí. El programa va de la base a la práctica: mercados, herramientas, entradas, gestión del riesgo y psicología. Los traders con experiencia cerrarán lagunas y sistematizarán su enfoque.' },
      { q: '¿Necesito un capital inicial grande?', a: 'No. Puedes empezar con poco: lo importante es el sistema y la disciplina. Y en el bonus mostramos cómo conseguir hasta $1M de capital bajo gestión.' },
      { q: '¿Cuánto tiempo hay que dedicar al trading?', a: 'Durante la masterclass: 15–30 minutos por lección y 20–30 minutos por tarea cada día. Después, 1–2 horas al día son suficientes.' },
      { q: '¿Cómo recibo el acceso a los materiales?', a: 'Justo después del pago: las lecciones y los materiales llegan a través del bot de Telegram, y el enlace al chat privado llega en la confirmación del registro.' },
      { q: '¿Hay garantía de devolución?', a: 'Sí. Garantía de devolución del dinero: 48 horas desde el inicio. Si ves que el formato no es para ti, te devolvemos el pago sin preguntas.' },
    ],
    finalTitle: 'Únete a la masterclass ahora mismo',
    timerTitle: 'La oferta termina en:',
    timerUnits: { h: 'horas', m: 'minutos', s: 'segundos' },
    ctaBtn2: 'Inscribirme ahora',
    ps: 'P.D. ¡No arriesgas nada! Garantía de devolución: 48 horas desde el inicio.',
    stickyBtn: 'Unirme con 90% de descuento',
  },
  account: {
    prompt: 'Inicia sesión para abrir tu cuenta',
    promptBtn: 'Iniciar sesión con Google',
    sub: 'Has iniciado sesión con tu cuenta de Google',
    logout: 'Cerrar sesión',
    since: 'Miembro desde',
  },
  pay: {
    title: 'Pago de la formación',
    sub: '¡Solicitud recibida! Elige el formato y completa el pago para reservar tu plaza en el grupo: inicio 18 de enero de 2027.',
    chooseLabel: 'Elige el formato',
    payBtn: 'Ir al pago',
    note: 'Pago seguro con Stripe · Tras el pago te contactaremos por Telegram',
  },
  selPay: {
    title: 'Pago de la selección',
    sub: '¡Solicitud recibida! Elige el formato y completa el pago: después el equipo te contactará por Telegram y te dará acceso al minicurso y a la etapa demo.',
    chooseLabel: 'Elige el formato',
  },
  crypto: {
    title: 'Pago con USDT',
    network: 'Red TRC20',
    walletLabel: 'Billetera',
    copy: 'Copiar',
    copied: 'Copiado',
    amount: 'Importe',
    hint: 'Envía el importe exacto a la billetera de abajo y pulsa el botón: verificaremos la transferencia y te daremos acceso.',
    paidBtn: 'Ya envié el pago',
    modalTitle: 'Confirmación de pago',
    modalSub: 'Indica tu nombre y Telegram: verificaremos la transacción y te contactaremos.',
    send: 'Enviar',
    success: 'Notificación enviada: verificaremos tu pago y te contactaremos',
  },
  form: {
    title: 'Dejar una solicitud',
    name: 'Nombre', namePh: '¿Cómo te llamamos?',
    telegram: 'Telegram', telegramPh: '@usuario',
    email: 'Email', emailPh: 'tu@ejemplo.com',
    phone: 'Teléfono', phonePh: '+34 600 000 000',
    experience: 'Experiencia de trading',
    expOptions: ['Sin experiencia', 'Menos de 1 año', '1–3 años', 'Más de 3 años'],
    message: 'Mensaje (opcional)', messagePh: 'Unas palabras sobre tu objetivo',
    submit: 'Enviar solicitud', sending: 'Enviando…',
    successTitle: 'Solicitud enviada',
    successText: 'Te contactaremos en un día laborable.',
    waitlistTitle: 'Lista de espera',
    waitlistSub: 'El grupo reducido está agotado. Deja tus datos — te escribiremos en cuanto se libere una plaza o se abra un nuevo grupo.',
    waitlistSuccessTitle: 'Estás en la lista de espera',
    waitlistSuccessText: 'Te contactaremos en cuanto haya una plaza disponible.',
    error: 'No se pudo enviar. Inténtalo de nuevo.',
  },
  footer: {
    tagline: 'Un equipo profesional de traders. NYSE & NASDAQ.',
    links: 'Secciones',
    risk: 'Advertencia de riesgo: operar en bolsa conlleva riesgo de pérdida de capital. Los resultados pasados no garantizan resultados futuros. El contenido es educativo y no constituye asesoramiento de inversión.',
    rights: '© 2026 ALEF Traders. Todos los derechos reservados.',
    tgBtn: 'Soporte en Telegram',
    marketOpen: 'Mercado abierto',
    marketClosed: 'Mercado cerrado',
  },
  countdown: { label: 'El grupo empieza en', d: 'días', h: 'h', m: 'min', s: 'seg' },
  dcapital,
  payment: {
    checking: 'Verificando tu pago…',
    successTitle: 'Pago realizado con éxito',
    successText: 'El acceso a la masterclass y a la guía bonus «Cómo conseguir hasta $1M de capital» llegará a través del bot de Telegram. Revisa tu correo y Telegram.',
    pendingText: 'Tu pago se está procesando: la página se actualizará automáticamente.',
    successTextTraining: 'Tu plaza en el grupo está reservada. El equipo te contactará por Telegram en un día laborable y te añadirá al chat privado.',
    successTextSelection: '¡Estás dentro! El equipo te contactará por Telegram en un día laborable y te dará acceso al minicurso y a la etapa demo.',
    backHome: 'Volver al inicio',
    cancelTitle: 'Pago cancelado',
    cancelText: 'No pasa nada: tu plaza sigue reservada. Puedes completar el pago en cualquier momento mientras dure el descuento.',
    retry: 'Volver a la masterclass',
    retryTraining: 'Volver a la formación',
    retrySelection: 'Volver al pago de la selección',
  },
};
